export const OrangeHS = () => {
  return (
    <div className="flex justify-center p-2 h-screen">
      <iframe
        className="p-4 h-screen w-screen"
        src="https://iframe.dacast.com/live/34722db9-4e7c-5b6a-03b1-492fb511cfd6/4a8c1a90-0329-4941-b65d-b52b95f3eb29"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Orange HS"
      />
    </div>
  );
};
